import styled from 'styled-components';

export const ViewWrapper = styled.div`
  width: ${(props) => 100 / props.columns}%;
  height: ${(props) => 100 / props.rows}%;
  background: transparent;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  overflow-y: auto;
  border: ${(props) => {
    const { typeOption, tempViewer } = props.layoutElement.initOptions || {};
    const { is3DModeEnabled, isMPRModeEnabled, series, selectedView, theme } = props;
    const hasSeries = series && (Object.keys(series).length !== 0);
    
    const borderColor = selectedView
        ? tempViewer === "vr" ? theme.colors.borderYellow :
          typeOption?.includes('coronal') ? theme.colors.borderRed :
          typeOption?.includes('axial') ? theme.colors.borderGreen :
          typeOption?.includes('sagittal') ? theme.colors.borderBlue :
          theme.colors.highlightBlue
        : theme.colors.gray800;

    const borderStyle = (is3DModeEnabled || isMPRModeEnabled) ? (hasSeries ? 'solid 2px' : 'none') : 'solid 2px';

    return `${borderStyle} ${borderColor}`;
  }};
  position: relative;
`;
